module.exports = __webpack_public_path__ + "img/Accesscontrolred.85e8df13.svg";